// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_6106781d","outerContainer":"_2fa3652a","secondaryToolbar":"a1625f16","doorHangerRight":"_54f77e34","toolbarContainer":"_7a3ffb7e","toolbarViewerMiddle":"be086ee2","progressBar":"b6c1eda7","back-to-application":"_8ddbbe64","consent":"_58ae94e7","title":"ab5a4a28","name":"f8a5e99e","idx":"fa040782","total":"_512d2edb","subtitle":"aa42d115","content":"_0eb1db50","footer":"_11f31136","button":"f3294bb1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Consents/ConsentDetails/styles.styl
// module id = 4936
// module chunks = 39